import React from "react";

export interface ShowIfProps {
    condition: boolean;
    className?: string;
    children: React.ReactNode;
}

export const ShowIf: React.FC<ShowIfProps> = (props: ShowIfProps) => {
    return <div style={{ display: props.condition ? '' : 'none' }} className={props.className}>
        {props.children}
    </div>;
}